import { render, staticRenderFns } from "./deanDialog.vue?vue&type=template&id=3ab79096&scoped=true"
import script from "./deanDialog.vue?vue&type=script&lang=ts"
export * from "./deanDialog.vue?vue&type=script&lang=ts"
import style0 from "./deanDialog.vue?vue&type=style&index=0&id=3ab79096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab79096",
  null
  
)

export default component.exports